import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Row,
  Col,
  Button,
  Form,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import IdentityInformationForm from "components/Customers/IdentityInformationForm";
import { useCreateCustomer } from "api/customers/service";
import { formatDateForAPI } from "utils/dateUtils";

function CustomerAdd() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // State for identity data
  const [identityData, setIdentityData] = useState({
    full_name: "",
    ssn: "",
    date_of_birth: null,
    gender: "",
    active_service_member: false,
    relationship_type: "",
    new_customer: true,
    customer_id: null,
  });

  // Create customer mutation
  const createCustomerMutation = useCreateCustomer({
    onClose: (customerId) => {
      navigate(customerId ? `/customers/${customerId}` : '/customers');
    }
  });

  // Helper function to check if required fields have values
  const hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (value instanceof Date) return true;
    if (typeof value === 'string') return value.trim() !== '';
    return Boolean(value);
  };

  // Check if form is valid: only full_name is required
  const isFormValid = hasValue(identityData.full_name);

  // Handle identity input changes
  const handleIdentityInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setIdentityData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid && !createCustomerMutation.isPending) {
      const payload = {
        ...identityData,
        date_of_birth: formatDateForAPI(identityData.date_of_birth),
      };
      createCustomerMutation.mutate(payload);
    }
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">{t('customers.addCustomer')}</CardTitle>
            </CardHeader>
            <CardBody style={{ paddingTop: '0px' }}>
              <Form onSubmit={handleSubmit}>
                <IdentityInformationForm
                  identityData={identityData}
                  onChange={handleIdentityInputChange}
                  showValidation={true}
                  showMatches={false}
                  handleSubmit={handleSubmit}
                  title={t('customers.identityInformation')}
                />

                <Row>
                  <Col md="12" className="text-right mt-3">
                    <Button
                      color="primary"
                      type="submit"
                      size="lg"
                      disabled={!isFormValid || createCustomerMutation.isPending}
                    >
                      {createCustomerMutation.isPending
                        ? t('common.loading')
                        : t('customers.addCustomer')
                      }
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default CustomerAdd;
